import { pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';

import { colors } from '@modernhealth/vital-foundation';

export const IndicatorDot = styled.span(({ diameter = 7 }: { diameter?: number }) => ({
    width: pxToRem(diameter),
    height: pxToRem(diameter),
    borderRadius: '50%',
    backgroundColor: colors.red55,
}));
